import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
} from '@mui/material';
import { NavLink } from 'react-router-dom';

export interface ListItems {
  name: string;
  link: string;
  selected: boolean;
}

interface LeftSideBarProps {
  items: ListItems[];
  adjustWidth?: number;
}

const defaultWidth = '100%';

const LeftSideMenu = ({ items, adjustWidth }: LeftSideBarProps) => {
  const finalWidth = adjustWidth ?? defaultWidth;

  return (
    <Box sx={{ width: finalWidth }}>
      <List disablePadding>
        {items.map((item, idx) => (
          <ListItem key={idx} disablePadding>
            <ListItemButton
              component={item.selected ? 'div' : NavLink}
              to={item.selected ? undefined : item.link}
              disabled={item.selected}
              selected={item.selected}
              sx={{
                m: 1,
                border: '1px solid',
                borderColor: item.selected ? 'primary.main' : 'grey.300',
                borderRadius: 1,
                bgcolor: item.selected ? 'primary.light' : 'background.paper',
                '&:hover': {
                  bgcolor: item.selected ? 'primary.light' : 'grey.100',
                },
              }}
            >
              <ListItemText primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default LeftSideMenu;
